import * as React from "react";

export const TextRequired = () => {
    return(<label id="my-helper-text" style={{color:'#d70909'}}>*</label>)
}